<div class="custom-container">
  <div class="row justify-content-center">
    <div class="col-md-5 align-content-center">
      <div class="wrapper">
        <div class="card-body">
          <img src="./assets/images/logo-2025.png" class="logo" alt="Logo" />
          <h5 class="card-title text-left">
            Para criar seu acesso a plataforma basta preencher os campos
            solicitados abaixo
          </h5>
          <form class="d-flex flex-column align-items-center mt-4">
            <div class="w-100">
              <label for="inputPassword" class="form-label"
                >Defina sua senha</label
              >

              <div class="password-input d-flex align-items-baseline mt-2">
                <input
                  class="form-input"
                  #inputPassword
                  type="{{ inputType[0] }}"
                  id="inputPassword"
                  name="password"
                  placeholder="Digite sua senha"
                  (keydown.enter)="onSubmit()"
                  [(ngModel)]="password"
                />
                @if (showPassword) {
                <ng-icon
                  (click)="toggleVisibility(0)"
                  class="icon"
                  name="heroEye"
                  color="#D6D6D6"
                  size="26"
                ></ng-icon>

                } @else {
                <ng-icon
                  (click)="toggleVisibility(0)"
                  class="icon"
                  name=" heroEyeSlash"
                  color="#D6D6D6"
                  size="26"
                ></ng-icon
                >}
              </div>

              <label for="inputPassword" class="form-label mt-4"
                >Confirmar senha</label
              >

              <div class="password-input d-flex align-items-baseline mt-2">
                <input
                  class="form-input"
                  #inputConfirm
                  type="{{ inputType[1] }}"
                  id="inputPassword"
                  name="password"
                  placeholder="Digite sua senha"
                  (keydown.enter)="onSubmit()"
                  [(ngModel)]="confirmPassword"
                />
                @if (showPassword) {
                <ng-icon
                  (click)="toggleVisibility(1)"
                  class="icon"
                  name="heroEye"
                  color="#D6D6D6"
                  size="26"
                ></ng-icon>

                } @else {
                <ng-icon
                  (click)="toggleVisibility(1)"
                  class="icon"
                  name=" heroEyeSlash"
                  color="#D6D6D6"
                  size="26"
                ></ng-icon
                >}
              </div>

              @if (inputPassword.value !== inputConfirm.value) {
              <p class="small text-danger mt-4">As senhas não coincidem!</p>

              }

              <button
                class="btn btn-no-auth mt-4"
                (click)="onSubmit()"
                [disabled]="inputPassword.value !== inputConfirm.value"
              >
                Finalizar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-6 slider">
      <app-slider></app-slider>
    </div>
  </div>
</div>
